export default () => {
    // silence is golden
}

// WEBPACK FOOTER //
// ./src/js/modules/SmoothScroll.js
